import React, { useState, useEffect } from 'react';
import SendMessageModal from '../components/SendMessageModal';
import { sendPerkProviderForm } from '../services/api';

function Tax() {
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState('');
  const [callbackForm, setCallbackForm] = useState({
    name: '',
    phone: '',
    email: '',
    businessType: 'Business Tax'
  });
  const [formStatus, setFormStatus] = useState(null); // null, 'sending', 'success', 'error'
  const [showAllBusinessTypes, setShowAllBusinessTypes] = useState(false);
  const [showAllIndustries, setShowAllIndustries] = useState(false);
  const [showAllIndividual, setShowAllIndividual] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [serviceType, setServiceType] = useState(null); // 'business', 'individual', or null
  const [showSecondaryService, setShowSecondaryService] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    // Read URL parameter for service type
    const urlParams = new URLSearchParams(window.location.search);
    const service = urlParams.get('service');
    
    if (service === 'business' || service === 'individual') {
      setServiceType(service);
      // Set default form value based on service type
      setCallbackForm(prev => ({
        ...prev,
        businessType: service === 'business' ? 'Business Tax' : 'Individual Tax'
      }));
    }
  }, []);

  useEffect(() => {
    // Track page view with GTM dataLayer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'page_view',
      page_title: 'Tax Services - rkube',
      page_location: window.location.href,
      page_path: window.location.pathname
    });
  }, []);

  const handleOpenModal = (type) => {
    setModalType(type);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setModalType('');
  };

  const handleCallbackSubmit = async (e) => {
    e.preventDefault();
    setFormStatus('sending');
    
    try {
      await sendPerkProviderForm({
        ...callbackForm,
        message: `Tax services callback request for ${callbackForm.businessType}`,
        subject: 'Tax Services Callback Request',
        type: 'tax_callback',
        source: 'tax_page'
      });
      
      setFormStatus('success');
      setCallbackForm({ name: '', phone: '', email: '', businessType: 'Business Tax' });
      
      setTimeout(() => {
        setFormStatus(null);
      }, 5000);
    } catch (error) {
      console.error('Error sending callback request:', error);
      setFormStatus('error');
      
      setTimeout(() => {
        setFormStatus(null);
      }, 5000);
    }
  };

  const handleCallbackChange = (e) => {
    const { name, value } = e.target;
    setCallbackForm(prev => ({ ...prev, [name]: value }));
  };

  return (
    <div className="service-page-container">
      {/* Add responsive CSS */}
      <style>{`
        .tax-hero-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 40px;
          align-items: center;
        }
        @media (max-width: 768px) {
          .tax-hero-grid {
            grid-template-columns: 1fr;
            gap: 30px;
          }
        }
      `}</style>

      {/* Compact Hero with Inline Form */}
      <div className="services-page-hero enhanced">
        <div className="container">
          <div className="tax-hero-grid">
            <div>
              <h1 style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>
                {serviceType === 'business' 
                  ? 'Business Tax Filing & Optimization' 
                  : serviceType === 'individual'
                  ? 'Individual Tax Filing & Preparation'
                  : 'Expert Tax Filing for Businesses & Individuals'}
              </h1>
              <p style={{ fontSize: '1.1rem', marginBottom: '1.5rem', lineHeight: '1.6' }}>
                {serviceType === 'business'
                  ? 'Specialized tax services for S-Corps, C-Corps, LLCs, and all business structures. Industry-specific expertise to maximize deductions and minimize liability.'
                  : serviceType === 'individual'
                  ? 'Professional individual tax preparation with personalized service. Maximize your credits, deductions, and refunds with expert guidance.'
                  : 'Maximize deductions. Minimize tax liability. Expert filing assistance.'}
              </p>
              <a 
                href="tel:+19842347030" 
                style={{ 
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '10px',
                  padding: '14px 24px',
                  background: '#10b981',
                  color: 'white',
                  fontWeight: 'bold',
                  fontSize: '1.1rem',
                  textDecoration: 'none',
                  borderRadius: '8px',
                  marginBottom: '1rem',
                  transition: 'background 0.2s',
                  boxShadow: '0 2px 8px rgba(16, 185, 129, 0.3)'
                }}
                onMouseOver={(e) => e.currentTarget.style.background = '#059669'}
                onMouseOut={(e) => e.currentTarget.style.background = '#10b981'}
              >
                <span style={{ fontSize: '1.3rem' }}>📞</span>
                (984) 234-7030
              </a>
              <p style={{ fontSize: '0.95rem', color: '#666' }}>
                {serviceType === 'business'
                  ? 'Trusted by construction companies, real estate investors, and businesses across industries.'
                  : serviceType === 'individual'
                  ? 'Trusted by professionals, freelancers, and families for accurate, personalized tax preparation.'
                  : 'Trusted by construction companies, real estate investors, and businesses across industries.'}
              </p>
            </div>
            
            {/* Quick Callback Form */}
            <div style={{ background: 'white', padding: '30px', borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
              <h3 style={{ margin: '0 0 20px 0', fontSize: '1.3rem' }}>Get a Free Tax Consultation</h3>
              {formStatus === 'success' ? (
                <div style={{ padding: '20px', background: '#d4edda', color: '#155724', borderRadius: '5px', textAlign: 'center' }}>
                  <p style={{ margin: 0 }}>✓ We'll call you shortly!</p>
                </div>
              ) : (
                <form onSubmit={handleCallbackSubmit}>
                  <div style={{ marginBottom: '15px' }}>
                    <input
                      type="text"
                      name="name"
                      placeholder="Your Name"
                      value={callbackForm.name}
                      onChange={handleCallbackChange}
                      required
                      style={{ width: '100%', padding: '12px', border: '1px solid #ddd', borderRadius: '5px', fontSize: '1rem' }}
                    />
                  </div>
                  <div style={{ marginBottom: '15px' }}>
                    <input
                      type="tel"
                      name="phone"
                      placeholder="Phone Number"
                      value={callbackForm.phone}
                      onChange={handleCallbackChange}
                      required
                      style={{ width: '100%', padding: '12px', border: '1px solid #ddd', borderRadius: '5px', fontSize: '1rem' }}
                    />
                  </div>
                  <div style={{ marginBottom: '15px' }}>
                    <input
                      type="email"
                      name="email"
                      placeholder="Email Address"
                      value={callbackForm.email}
                      onChange={handleCallbackChange}
                      required
                      style={{ width: '100%', padding: '12px', border: '1px solid #ddd', borderRadius: '5px', fontSize: '1rem' }}
                    />
                  </div>
                  <div style={{ marginBottom: '20px' }}>
                    <select
                      name="businessType"
                      value={callbackForm.businessType}
                      onChange={handleCallbackChange}
                      style={{ width: '100%', padding: '12px', border: '1px solid #ddd', borderRadius: '5px', fontSize: '1rem' }}
                    >
                      <option value="Business Tax">Business Tax Filing</option>
                      <option value="Individual Tax">Individual Tax Filing</option>
                      <option value="Both">Both Business & Individual</option>
                    </select>
                  </div>
                  <button
                    type="submit"
                    disabled={formStatus === 'sending'}
                    style={{
                      width: '100%',
                      padding: '14px',
                      background: '#6366f1',
                      color: 'white',
                      border: 'none',
                      borderRadius: '5px',
                      fontSize: '1.1rem',
                      fontWeight: 'bold',
                      cursor: formStatus === 'sending' ? 'not-allowed' : 'pointer',
                      opacity: formStatus === 'sending' ? 0.7 : 1
                    }}
                  >
                    {formStatus === 'sending' ? 'Submitting...' : 'Request Callback'}
                  </button>
                  {formStatus === 'error' && (
                    <p style={{ marginTop: '10px', color: '#dc3545', fontSize: '0.9rem', textAlign: 'center' }}>
                      Error submitting. Please call us directly.
                    </p>
                  )}
                </form>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="service-page-content">
          {/* Render Business section first when business is selected or no specific service */}
          {(serviceType === 'business' || serviceType === null) && (
            <section style={{ marginBottom: '40px' }}>
              {serviceType === 'business' && (
                <div style={{ 
                  display: 'inline-block', 
                  background: '#6366f1', 
                  color: 'white', 
                  padding: '6px 16px', 
                  borderRadius: '20px', 
                  fontSize: '0.85rem', 
                  fontWeight: 'bold',
                  marginBottom: '15px'
                }}>
                  ⭐ OUR SPECIALTY
                </div>
              )}
              <h2 style={{ fontSize: '2rem', marginBottom: '10px' }}>Business Tax Services</h2>
              <p style={{ color: '#666', marginBottom: '25px' }}>Expert filing for all business structures with industry-specific expertise.</p>
            
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '20px', marginBottom: '15px' }}>
              {[
                { title: 'S-Corporations', desc: 'Form 1120S, K-1 prep, payroll optimization, quarterly estimates' },
                { title: 'C-Corporations', desc: 'Form 1120, multi-state compliance, corporate planning, M&A support' },
                { title: 'LLCs & Partnerships', desc: 'Form 1065, K-1s for all members, profit/loss allocation' },
                { title: 'Sole Proprietors', desc: 'Schedule C, self-employment tax, home office, mileage' },
                { title: 'Trusts & Estates', desc: 'Form 1041, beneficiary distributions, trust income taxation' },
                { title: 'Non-Profits', desc: 'Form 990, tax-exempt status, unrelated business income (UBIT)' }
              ].slice(0, isMobile && !showAllBusinessTypes ? 3 : 6).map((item, idx) => (
                <div key={idx} style={{ padding: '20px', background: '#f8f9fa', borderRadius: '8px', borderLeft: '4px solid #6366f1' }}>
                  <h4 style={{ margin: '0 0 10px 0', fontSize: '1.1rem' }}>{item.title}</h4>
                  <p style={{ margin: 0, fontSize: '0.9rem', color: '#555' }}>{item.desc}</p>
                </div>
              ))}
            </div>
            {isMobile && (
              <button
                onClick={() => setShowAllBusinessTypes(!showAllBusinessTypes)}
                style={{
                  display: 'block',
                  margin: '0 auto 20px auto',
                  padding: '10px 20px',
                  background: 'transparent',
                  color: '#6366f1',
                  border: '2px solid #6366f1',
                  borderRadius: '5px',
                  fontSize: '0.95rem',
                  fontWeight: 'bold',
                  cursor: 'pointer'
                }}
              >
                {showAllBusinessTypes ? '▲ Show Less' : '▼ Show More Business Types'}
              </button>
            )}

            <h3 style={{ fontSize: '1.5rem', marginBottom: '15px' }}>Industries We Specialize In</h3>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '15px', marginBottom: '15px' }}>
              {[
                { icon: '🏗️', title: 'Construction & Contractors', desc: 'Equipment depreciation, job costing, subcontractor payments, vehicle expenses' },
                { icon: '🏘️', title: 'Real Estate Investors', desc: 'Rental property income, depreciation, 1031 exchanges, passive activity rules' },
                { icon: '🛒', title: 'E-commerce & Retail', desc: 'Inventory accounting, sales tax nexus, marketplace fees, multi-state compliance' },
                { icon: '💼', title: 'Professional Services', desc: 'Consulting, legal, medical—maximize home office, equipment, travel deductions' },
                { icon: '🍽️', title: 'Restaurants & Hospitality', desc: 'Tip reporting, inventory, employee meals, equipment, hospitality credits' },
                { icon: '🔧', title: 'Trades & Services', desc: 'Plumbing, electrical, HVAC—tool deductions, vehicle expenses, licensing' },
                { icon: '💻', title: 'Technology & Software', desc: 'SaaS companies, R&D credits, software development costs, equipment depreciation' },
                { icon: '⚕️', title: 'Healthcare & Medical', desc: 'Medical practices, dental offices, veterinary—equipment, malpractice insurance, supplies' }
              ].slice(0, isMobile && !showAllIndustries ? 1 : 8).map((item, idx) => (
                <div key={idx} style={{ padding: '15px', background: '#fff', border: '1px solid #e5e7eb', borderRadius: '6px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
                    <span style={{ fontSize: '1.5rem' }}>{item.icon}</span>
                    <h4 style={{ margin: 0, fontSize: '1rem' }}>{item.title}</h4>
                  </div>
                  <p style={{ margin: 0, fontSize: '0.85rem', color: '#666' }}>{item.desc}</p>
                </div>
              ))}
            </div>
            {isMobile && (
              <button
                onClick={() => setShowAllIndustries(!showAllIndustries)}
                style={{
                  display: 'block',
                  margin: '0 auto 20px auto',
                  padding: '10px 20px',
                  background: 'transparent',
                  color: '#6366f1',
                  border: '2px solid #6366f1',
                  borderRadius: '5px',
                  fontSize: '0.95rem',
                  fontWeight: 'bold',
                  cursor: 'pointer'
                }}
              >
                {showAllIndustries ? '▲ Show Less' : '▼ Show More Industries'}
              </button>
            )}
            </section>
          )}

          {/* Render Individual section first when individual is selected */}
          {serviceType === 'individual' && (
            <section style={{ marginBottom: '40px' }}>
              <div style={{ 
                display: 'inline-block', 
                background: '#6366f1', 
                color: 'white', 
                padding: '6px 16px', 
                borderRadius: '20px', 
                fontSize: '0.85rem', 
                fontWeight: 'bold',
                marginBottom: '15px'
              }}>
                ⭐ OUR SPECIALTY
              </div>
              <h2 style={{ fontSize: '2rem', marginBottom: '10px' }}>Individual Tax Services</h2>
              <p style={{ color: '#666', marginBottom: '20px' }}>Personal tax preparation to help maximize your credits and deductions.</p>
            
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '15px', marginBottom: '15px' }}>
              {[
                { icon: '📄', title: 'Standard Returns', desc: 'W-2 employees, Form 1040, itemized/standard deductions' },
                { icon: '🏠', title: 'Rental Property Owners', desc: 'Schedule E, rental income/expenses, depreciation' },
                { icon: '💻', title: 'Freelancers & Gig Workers', desc: '1099 income, self-employment tax, quarterly estimates' },
                { icon: '📈', title: 'Investment Income', desc: 'Capital gains, dividends, stock options, cryptocurrency' },
                { icon: '🗺️', title: 'Multi-State Returns', desc: 'Filing in multiple states, remote work, residency' },
                { icon: '🎓', title: 'Special Situations', desc: 'Marriage, divorce, home sales, education credits' }
              ].slice(0, isMobile && !showAllIndividual ? 2 : 6).map((item, idx) => (
                <div key={idx} style={{ padding: '15px', background: '#f8f9fa', borderRadius: '6px' }}>
                  <h4 style={{ margin: '0 0 8px 0', fontSize: '1rem' }}>{item.icon} {item.title}</h4>
                  <p style={{ margin: 0, fontSize: '0.85rem', color: '#555' }}>{item.desc}</p>
                </div>
              ))}
            </div>
            {isMobile && (
              <button
                onClick={() => setShowAllIndividual(!showAllIndividual)}
                style={{
                  display: 'block',
                  margin: '0 auto',
                  padding: '10px 20px',
                  background: 'transparent',
                  color: '#6366f1',
                  border: '2px solid #6366f1',
                  borderRadius: '5px',
                  fontSize: '0.95rem',
                  fontWeight: 'bold',
                  cursor: 'pointer'
                }}
              >
                {showAllIndividual ? '▲ Show Less' : '▼ Show More Individual Services'}
              </button>
            )}
            </section>
          )}

          {/* Secondary service section for Individual (when business is primary) */}
          {serviceType === 'business' && (
            <section style={{ marginBottom: '40px', padding: '30px', background: '#f8f9fa', borderRadius: '8px' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '15px', flexWrap: 'wrap', gap: '15px' }}>
                <div>
                  <h3 style={{ fontSize: '1.5rem', margin: '0 0 5px 0' }}>We Also Offer Individual Tax Services</h3>
                  <p style={{ margin: 0, color: '#666' }}>Personal tax preparation for W-2 employees, freelancers, investors, and more.</p>
                </div>
                <button
                  onClick={() => setShowSecondaryService(!showSecondaryService)}
                  style={{
                    padding: '10px 20px',
                    background: 'white',
                    color: '#6366f1',
                    border: '2px solid #6366f1',
                    borderRadius: '5px',
                    fontSize: '0.95rem',
                    fontWeight: 'bold',
                    cursor: 'pointer',
                    whiteSpace: 'nowrap'
                  }}
                >
                  {showSecondaryService ? '▲ Show Less' : '▼ Learn More'}
                </button>
              </div>
              
              {showSecondaryService && (
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '15px', marginTop: '20px' }}>
                  {[
                    { icon: '📄', title: 'Standard Returns', desc: 'W-2 employees, Form 1040, itemized/standard deductions' },
                    { icon: '🏠', title: 'Rental Property Owners', desc: 'Schedule E, rental income/expenses, depreciation' },
                    { icon: '💻', title: 'Freelancers & Gig Workers', desc: '1099 income, self-employment tax, quarterly estimates' },
                    { icon: '📈', title: 'Investment Income', desc: 'Capital gains, dividends, stock options, cryptocurrency' },
                    { icon: '🗺️', title: 'Multi-State Returns', desc: 'Filing in multiple states, remote work, residency' },
                    { icon: '🎓', title: 'Special Situations', desc: 'Marriage, divorce, home sales, education credits' }
                  ].map((item, idx) => (
                    <div key={idx} style={{ padding: '15px', background: 'white', borderRadius: '6px', border: '1px solid #e5e7eb' }}>
                      <h4 style={{ margin: '0 0 8px 0', fontSize: '1rem' }}>{item.icon} {item.title}</h4>
                      <p style={{ margin: 0, fontSize: '0.85rem', color: '#555' }}>{item.desc}</p>
                    </div>
                  ))}
                </div>
              )}
            </section>
          )}

          {/* Secondary service section for Business (when individual is primary) */}
          {serviceType === 'individual' && (
            <section style={{ marginBottom: '40px', padding: '30px', background: '#f8f9fa', borderRadius: '8px' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '15px', flexWrap: 'wrap', gap: '15px' }}>
                <div>
                  <h3 style={{ fontSize: '1.5rem', margin: '0 0 5px 0' }}>We Also Offer Business Tax Services</h3>
                  <p style={{ margin: 0, color: '#666' }}>Full-service tax filing for S-Corps, C-Corps, LLCs, Partnerships, and all business structures.</p>
                </div>
                <button
                  onClick={() => setShowSecondaryService(!showSecondaryService)}
                  style={{
                    padding: '10px 20px',
                    background: 'white',
                    color: '#6366f1',
                    border: '2px solid #6366f1',
                    borderRadius: '5px',
                    fontSize: '0.95rem',
                    fontWeight: 'bold',
                    cursor: 'pointer',
                    whiteSpace: 'nowrap'
                  }}
                >
                  {showSecondaryService ? '▲ Show Less' : '▼ Learn More'}
                </button>
              </div>
              
              {showSecondaryService && (
                <>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '20px', marginTop: '20px', marginBottom: '30px' }}>
                    {[
                      { title: 'S-Corporations', desc: 'Form 1120S, K-1 prep, payroll optimization, quarterly estimates' },
                      { title: 'C-Corporations', desc: 'Form 1120, multi-state compliance, corporate planning, M&A support' },
                      { title: 'LLCs & Partnerships', desc: 'Form 1065, K-1s for all members, profit/loss allocation' },
                      { title: 'Sole Proprietors', desc: 'Schedule C, self-employment tax, home office, mileage' },
                      { title: 'Trusts & Estates', desc: 'Form 1041, beneficiary distributions, trust income taxation' },
                      { title: 'Non-Profits', desc: 'Form 990, tax-exempt status, unrelated business income (UBIT)' }
                    ].map((item, idx) => (
                      <div key={idx} style={{ padding: '20px', background: 'white', borderRadius: '8px', borderLeft: '4px solid #6366f1' }}>
                        <h4 style={{ margin: '0 0 10px 0', fontSize: '1.1rem' }}>{item.title}</h4>
                        <p style={{ margin: 0, fontSize: '0.9rem', color: '#555' }}>{item.desc}</p>
                      </div>
                    ))}
                  </div>
                  
                  <div>
                    <h4 style={{ fontSize: '1.3rem', marginBottom: '15px' }}>Industry Expertise</h4>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '15px' }}>
                      {[
                        { icon: '🏗️', title: 'Construction & Contractors' },
                        { icon: '🏘️', title: 'Real Estate Investors' },
                        { icon: '🛒', title: 'E-commerce & Retail' },
                        { icon: '💼', title: 'Professional Services' },
                        { icon: '🍽️', title: 'Restaurants & Hospitality' },
                        { icon: '🔧', title: 'Trades & Services' },
                        { icon: '💻', title: 'Technology & Software' },
                        { icon: '⚕️', title: 'Healthcare & Medical' }
                      ].map((item, idx) => (
                        <div key={idx} style={{ padding: '12px', background: 'white', border: '1px solid #e5e7eb', borderRadius: '6px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                          <span style={{ fontSize: '1.3rem' }}>{item.icon}</span>
                          <span style={{ fontSize: '0.9rem', fontWeight: '500' }}>{item.title}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </>
              )}
            </section>
          )}

          {/* Default view - show Individual section as normal */}
          {serviceType === null && (
            <section style={{ marginBottom: '40px' }}>
              <h2 style={{ fontSize: '2rem', marginBottom: '10px' }}>Individual Tax Services</h2>
              <p style={{ color: '#666', marginBottom: '20px' }}>Personal tax preparation to help maximize your credits and deductions.</p>
              
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '15px', marginBottom: '15px' }}>
                {[
                  { icon: '📄', title: 'Standard Returns', desc: 'W-2 employees, Form 1040, itemized/standard deductions' },
                  { icon: '🏠', title: 'Rental Property Owners', desc: 'Schedule E, rental income/expenses, depreciation' },
                  { icon: '💻', title: 'Freelancers & Gig Workers', desc: '1099 income, self-employment tax, quarterly estimates' },
                  { icon: '📈', title: 'Investment Income', desc: 'Capital gains, dividends, stock options, cryptocurrency' },
                  { icon: '🗺️', title: 'Multi-State Returns', desc: 'Filing in multiple states, remote work, residency' },
                  { icon: '🎓', title: 'Special Situations', desc: 'Marriage, divorce, home sales, education credits' }
                ].slice(0, isMobile && !showAllIndividual ? 2 : 6).map((item, idx) => (
                  <div key={idx} style={{ padding: '15px', background: '#f8f9fa', borderRadius: '6px' }}>
                    <h4 style={{ margin: '0 0 8px 0', fontSize: '1rem' }}>{item.icon} {item.title}</h4>
                    <p style={{ margin: 0, fontSize: '0.85rem', color: '#555' }}>{item.desc}</p>
                  </div>
                ))}
              </div>
              {isMobile && (
                <button
                  onClick={() => setShowAllIndividual(!showAllIndividual)}
                  style={{
                    display: 'block',
                    margin: '0 auto',
                    padding: '10px 20px',
                    background: 'transparent',
                    color: '#6366f1',
                    border: '2px solid #6366f1',
                    borderRadius: '5px',
                    fontSize: '0.95rem',
                    fontWeight: 'bold',
                    cursor: 'pointer'
                  }}
                >
                  {showAllIndividual ? '▲ Show Less' : '▼ Show More Individual Services'}
                </button>
              )}
            </section>
          )}

          {/* Compact Benefits */}
          <section style={{ marginBottom: '40px', padding: '30px', background: '#f8f9fa', borderRadius: '8px' }}>
            <h2 style={{ fontSize: '1.8rem', marginBottom: '20px' }}>Why Choose rkube?</h2>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '15px' }}>
              <div>
                <div style={{ display: 'flex', alignItems: 'start', gap: '10px' }}>
                  <span style={{ fontSize: '1.2rem', marginTop: '2px' }}>✓</span>
                  <div>
                    <strong>Industry Expertise</strong>
                    <p style={{ margin: '5px 0 0 0', fontSize: '0.9rem', color: '#555' }}>We know construction, real estate, e-commerce deductions inside-out</p>
                  </div>
                </div>
              </div>
              <div>
                <div style={{ display: 'flex', alignItems: 'start', gap: '10px' }}>
                  <span style={{ fontSize: '1.2rem', marginTop: '2px' }}>✓</span>
                  <div>
                    <strong>Maximum Tax Savings</strong>
                    <p style={{ margin: '5px 0 0 0', fontSize: '0.9rem', color: '#555' }}>Help identify credits, deductions, and tax breaks you may qualify for</p>
                  </div>
                </div>
              </div>
              <div>
                <div style={{ display: 'flex', alignItems: 'start', gap: '10px' }}>
                  <span style={{ fontSize: '1.2rem', marginTop: '2px' }}>✓</span>
                  <div>
                    <strong>Year-Round Support</strong>
                    <p style={{ margin: '5px 0 0 0', fontSize: '0.9rem', color: '#555' }}>Not just tax season—quarterly estimates, planning anytime</p>
                  </div>
                </div>
              </div>
              <div>
                <div style={{ display: 'flex', alignItems: 'start', gap: '10px' }}>
                  <span style={{ fontSize: '1.2rem', marginTop: '2px' }}>✓</span>
                  <div>
                    <strong>Expert Support</strong>
                    <p style={{ margin: '5px 0 0 0', fontSize: '0.9rem', color: '#555' }}>Accurate filings with professional guidance whenever you need it</p>
                  </div>
                </div>
              </div>
              <div>
                <div style={{ display: 'flex', alignItems: 'start', gap: '10px' }}>
                  <span style={{ fontSize: '1.2rem', marginTop: '2px' }}>✓</span>
                  <div>
                    <strong>Fast & Accurate</strong>
                    <p style={{ margin: '5px 0 0 0', fontSize: '0.9rem', color: '#555' }}>Timely filing with thorough review and attention to detail</p>
                  </div>
                </div>
              </div>
              <div>
                <div style={{ display: 'flex', alignItems: 'start', gap: '10px' }}>
                  <span style={{ fontSize: '1.2rem', marginTop: '2px' }}>✓</span>
                  <div>
                    <strong>Personalized Service</strong>
                    <p style={{ margin: '5px 0 0 0', fontSize: '0.9rem', color: '#555' }}>Real tax pros who understand your specific situation</p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="service-pricing">
            <h2>Tax Filing Pricing</h2>
            <div className="pricing-container">
              <div className="pricing-card starter">
                <h3>Starter Tax</h3>
                <div className="price">Starts at $300<span>/filing</span></div>
                <p className="pricing-description">For sole proprietors, single-member LLCs & basic S-Corps</p>
                <ul className="pricing-features">
                  <li>Schedule C (Sole Proprietor)</li>
                  <li>Single-member LLC (Form 1040)</li>
                  <li>Basic S-Corp filing (Form 1120S)</li>
                  <li>Single K-1 preparation</li>
                  <li>Basic business income & expenses</li>
                  <li>Single state filing</li>
                  <li>Standard deductions</li>
                  <li>Basic business expense tracking</li>
                  <li>Self-employment tax calculation</li>
                  <li>Email support</li>
                </ul>
                <p className="pricing-note">
                  * Perfect for freelancers, consultants, and single-owner businesses. Basic S-Corp filing limited to single owner with minimal complexity. Additional services like quarterly filings, payroll, and advanced tax planning available as add-ons.
                </p>
                <button 
                  className="signup-button" 
                  onClick={() => handleOpenModal('starter')}
                >
                  Sign Up Now
                </button>
              </div>

              <div className="pricing-card growth">
                <h3>Growth Tax</h3>
                <div className="price">Starts at $800<span>/filing</span></div>
                <p className="pricing-description">For multi-member LLCs & S-Corporations</p>
                <ul className="pricing-features">
                  <li>Multi-member LLC (Form 1065)</li>
                  <li>S-Corporation (Form 1120S)</li>
                  <li>Up to 20 W-2 employees</li>
                  <li>Multi-state operations (up to 3 states)</li>
                  <li>Inventory management</li>
                  <li>Equipment & asset depreciation</li>
                  <li>Basic R&D credit identification</li>
                  <li>K-1 preparation</li>
                  <li>Quarterly estimated tax filings</li>
                  <li>Stock option administration & compliance</li>
                  <li>ISO/NSO exercise tracking</li>
                  <li>Priority support</li>
                </ul>
                <p className="pricing-note">
                  * For growing businesses with multiple owners. R&D credits and 409A valuations billed separately. Includes quarterly tax planning.
                </p>
                <button 
                  className="get-started-button" 
                  onClick={() => handleOpenModal('growth')}
                >
                  Get Started
                </button>
              </div>

              <div className="pricing-card scale">
                <h3>Enterprise Tax</h3>
                <div className="price">Custom<span>/year</span></div>
                <p className="pricing-description">For C-Corporations & complex structures</p>
                <ul className="pricing-features">
                  <li>C-Corporation (Form 1120)</li>
                  <li>Complex multi-entity structures</li>
                  <li>Unlimited W-2 employees</li>
                  <li>Unlimited state filings</li>
                  <li>International operations</li>
                  <li>M&A transaction support</li>
                  <li>Full R&D credit optimization & documentation</li>
                  <li>Strategic tax planning</li>
                  <li>Complex stock option scenarios</li>
                  <li>International stock plan compliance</li>
                  <li>Employee stock purchase plans (ESPP)</li>
                  <li>Restricted stock units (RSUs)</li>
                  <li>24/7 dedicated support</li>
                </ul>
                <p className="pricing-note">
                  * For established businesses with complex operations. Custom pricing based on entity structure, transaction volume, and specific needs. Includes dedicated tax team and comprehensive planning.
                </p>
                <button 
                  className="book-call-button" 
                  onClick={() => handleOpenModal('enterprise')}
                >
                  Book a Call
                </button>
              </div>
            </div>

            <div className="pricing-additional-info">
              <h3>Additional Services</h3>
              <div className="additional-services-grid">
                <div className="additional-service-card">
                  <h4>R&D Tax Credits</h4>
                  <p>Our R&D credit services are tailored to your business complexity:</p>
                  <ul>
                    <li>Basic Identification: $2,500 - $5,000</li>
                    <li>Full Documentation: $5,000 - $15,000</li>
                    <li>Complex Optimization: Custom pricing</li>
                  </ul>
                  <p className="service-note">* Pricing varies based on company size, project complexity, and documentation needs</p>
                </div>
                <div className="additional-service-card">
                  <h4>Tax Planning & Strategy</h4>
                  <p>Comprehensive tax planning services:</p>
                  <ul>
                    <li>Quarterly Planning: $1,500/quarter</li>
                    <li>Annual Strategy: $5,000/year</li>
                    <li>Custom Solutions: Custom pricing</li>
                  </ul>
                  <p className="service-note">* Includes regular reviews and strategic recommendations</p>
                </div>
                <div className="additional-service-card">
                  <h4>Section 409A Valuations</h4>
                  <p>Independent third-party valuations for private companies:</p>
                  <ul>
                    <li>Initial Valuation: $5,000 - $10,000</li>
                    <li>Annual Update: $3,000 - $7,000</li>
                    <li>Material Event Update: $2,500 - $5,000</li>
                  </ul>
                  <p className="service-note">* Required for private companies issuing stock options. Pricing based on company stage, complexity, and funding status. Includes full documentation and IRS compliance review.</p>
                </div>
              </div>
            </div>
          </section>

          {/* Tools Flexibility Section */}
          <section className="tools-flexibility">
            <h2>Flexible Tax Solutions for Your Business</h2>
            <p>Our adaptive approach to tax services means you can choose what works best for your business structure and needs.</p>
            
            <div className="tools-options">
              <div className="tool-option">
                <div className="tool-option-icon">
                  <span>📊</span>
                </div>
                <h3>Full-Service Tax Management</h3>
                <p>We handle tax planning through filing with our comprehensive suite of tax services and expert team.</p>
              </div>
              
              <div className="tool-option">
                <div className="tool-option-icon">
                  <span>⚙️</span>
                </div>
                <h3>Custom Tax Solutions</h3>
                <p>Need specific tax services? We can tailor our offerings to your unique requirements, whether it's R&D credits, SALT, or specialized tax planning.</p>
              </div>
            </div>
          </section>
        </div>
      </div>

      {showModal && (
        <SendMessageModal
          formName={
            modalType === 'growth' 
              ? 'Growth Tax Package' 
              : modalType === 'enterprise' 
                ? 'Enterprise Tax Package'
                : 'Starter Tax Package'
          }
          onClose={handleCloseModal}
          showDatePicker={modalType === 'enterprise'}
        />
      )}
    </div>
  );
}

export default Tax; 